package com.daytimegaming.ourdailyfinances.domain.account

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

class AccountEventBus {
    private val _events = MutableSharedFlow<String?>(extraBufferCapacity = 64)
    val events: SharedFlow<String?> = _events.asSharedFlow()

    suspend fun accountChanged(accountId: String? = null) {
        _events.emit(accountId)
    }

    fun tryEmitAccountChanged(accountId: String? = null) {
        _events.tryEmit(accountId)
    }
}
